const deviceEventSettings = window.filterEnvironmentDeviceSettings(
  require('cloud-utils/config/events/default.json').deviceEventSettings
)
const { LOAD_DEVICE_DETAILS } = require('../../constants/commonEvents')

angular
  .module('surfsightApp.controllers')

  .controller('edgeEventsController', [
    '$scope',
    '$rootScope',
    '$state',
    '$timeout',
    '$http',
    '$localStorage',
    '$mdDialog',
    'edgeFactoryV2',
    '$stateParams',
    'SystemConstants',
    'UnitSystem',
    function (
      $scope,
      $rootScope,
      $state,
      $timeout,
      $http,
      $localStorage,
      $mdDialog,
      edgeFactoryV2,
      $stateParams,
      SystemConstants,
      UnitSystem
    ) {
      $scope.topIndex = 1

      const { item } = edgeFactoryV2.findItemByImei($stateParams.imei)
      $scope.edge = item

      $scope.available_edge_event_settings = angular.copy(deviceEventSettings)
      let selectedFilterEvents = $scope.available_edge_event_settings.filter(
        e => !['acc_on', 'acc_off'].includes(e.name)
      )
      $scope.available_edge_event_settings_parsed = {}
      deviceEventSettings.forEach(function (s) {
        $scope.available_edge_event_settings_parsed[s.v2Name] = s
      })
      $scope.resetEventSearch = function () {
        $scope.eventSearch = {
          id: 1,
          name: Date.today().toString('dddd, dd MMM yyyy'),
          name_formate1: 'today',
          name_formate2: Date.today().toString('MMM dd '),
          date: {
            // start: 0,
            start: Date.today().getTime(),
            end: Date.today()
              .add(1)
              .day()
              .getTime()
          }
        }
      }
      $scope.getEdgeEvents = function (edge, isInitial = false) {
        $scope.selected_gps_events_edge = edge
        let start = moment($scope.eventSearch.date.start).format()
        let end = moment($scope.eventSearch.date.end).format()

        if (isInitial) {
          start = moment()
            .startOf('day')
            .format()
          end = moment()
            .startOf('day')
            .add(1, 'days')
            .format()
        }

        let deepLinkEventVideoShown = true
        $localStorage.deeplinkEventVideo &&
          (deepLinkEventVideoShown = $localStorage.deeplinkEventVideo.shown)
        if (
          $localStorage.deeplinkEventVideo &&
          !$localStorage.deeplinkEventVideo.shown
        ) {
          $localStorage.deeplinkEventVideo.shown = true
          start = moment($localStorage.deeplinkEventVideo.time * 1000).format()
          end = moment($localStorage.deeplinkEventVideo.time * 1000).format()
        }
        const filteredEventType =
          ($localStorage.deeplinkEventVideo &&
            $localStorage.deeplinkEventVideo.msg_type) ||
          null
        $scope.edge_event_history_loading = true
        edgeFactoryV2.getDeviceEvents(edge.imei, start, end).then(
          data => {
            $localStorage.deeplinkEventVideo = null
            $scope.edge_event_history_loading = false
            $scope.disabledValue = false

            $scope.scrolllValue = false
            const edgeEvents = data.map(event => {
              if ($localStorage.timeFormat === 2) {
                event.time_string_formate = moment(event.time).format(
                  'h:mm:ss A MMM DD YYYY'
                )
              } else {
                event.time_string_formate = moment(event.time).format(
                  'HH:mm:ss MMM DD YYYY'
                )
              }
              event.edge_setting =
                $scope.available_edge_event_settings_parsed[event.eventType]
              event.location = event.lat + ',' + event.lon
              event.location_update = false

              return event
            })
            $scope.total_edge_events = $scope.edge_events_array.concat(
              edgeEvents
            )
            $scope.edge_events_array = $scope.edge_events_array.concat(
              edgeEvents
            )
            const filteredEvent = filteredEventType
              ? $scope.edge_events_array.find(
                  event => event.eventType === filteredEventType
                ) || $scope.edge_events_array[0]
              : $scope.edge_events_array[0]
            if (!deepLinkEventVideoShown) {
              $scope.showEventVidoesModal(edge, filteredEvent, null)

              $scope.edge_events_array = []
              $scope.total_edge_events = []
              $scope.getEdgeEvents(edge, true)
              return
            }
            $scope.filteringEventsModule(selectedFilterEvents)
            $scope.updateEdgeEventStastics()
          },
          function (response) {
            if (isInitial) {
              isInitial = false
            }
            $scope.edge_event_history_loading = false
            $scope.filteringEventsModule($scope.available_edge_event_settings)
            $scope.updateEdgeEventStastics()
            $scope.disabledValue = true
            handleServerError(response)
          }
        )
      }
      $scope.showDriverInfo = event => typeof event.driver !== 'undefined'
      $scope.showVehicleInfo = event => typeof event.vehicle !== 'undefined'

      $scope.showEdgeEventHistory = function (edge) {
        $scope.existEvents = angular.copy(deviceEventSettings)
        $scope.edge = edge
        $scope.edge_events[edge.id] = []
        $scope.getEdgeEvents(edge, true)
      }
      $scope.updateEdgeEventStastics = function () {
        var countsObject = {}
        $scope.existEvents.forEach(function (ev) {
          countsObject[ev.v2Name] = 0
        })
        $scope.edge_events_array.forEach(function (event) {
          countsObject[event.eventType]++
          $scope.last_event_id = event.id
        })
        $scope.existEvents.forEach(function (ev, i) {
          $scope.existEvents[i].count = countsObject[ev.v2Name]
        })
      }

      $scope.showEdgeEventSettings = function (edge, ev = null) {
        $mdDialog
          .show({
            locals: {
              dataFromCaller: {
                edge: edge
              }
            },
            controller: 'EdgeEventSettingsController',
            templateUrl:
              './templates/edge.event.settings.view.html?t=' +
              window.webpackHash,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(
            function (response) {},
            function () {
              //
            }
          )
      }
      $scope.showEventDateFilter = function (ev) {
        $mdDialog
          .show({
            controller: 'EdgeEventDateFilter',
            // controller: function(){},
            templateUrl:
              './templates/edge.event.date.filter.view.html?t=' +
              window.webpackHash,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(
            function (response) {
              $scope.eventSearch = response
              $scope.eventSearch = response
              $rootScope.eventSearch = response
              $scope.filterActivated = false
              $scope.edge_events_array = []
              $scope.total_edge_events = []
              isInitial = false
              $scope.getEdgeEvents($scope.edge)
              $scope.dateFilterResponse = response
              $scope.$emit('eventSearchData', {
                response
              })
            },
            function () {}
          )
      }
      $scope.hideEventsSidenav = function () {
        $scope.$emit('controlEdgeEvents', {})
        $state.go('home.common.events')
      }
      $scope.updateProgressBarStaus = function (edge_event_id, eventurlid) {
        var vid = 'event-' + edge_event_id + '-video-' + eventurlid
        vid = document.getElementById(vid)
        if (vid) {
          var seeksliderID = edge_event_id + '-seekslider-' + eventurlid
          var seekslider = document.getElementById(seeksliderID)
          var seekto = vid.duration * (seekslider.value / 100)
          vid.currentTime = seekto
        }
      }
      $scope.play_pause_video = function (edge_event, eventurl) {
        var elem = 'event-' + edge_event.id + '-video-' + eventurl.id
        elem = document.getElementById(elem)
        // elem.addEventListener('timeupdate',  function(){ seektimeupdate(edge_event.id,eventurl.id); }, false);
        if (elem.paused) {
          elem.play()
          $scope.edge_events_array[eventurl.event_index].event_video_urls[
            eventurl.id - 1
          ].playStatus = true
        } else {
          elem.pause()
          $scope.edge_events_array[eventurl.event_index].event_video_urls[
            eventurl.id - 1
          ].playStatus = false
        }
      }
      $scope.setFullscreen = function (edge_event, eventurlid) {
        try {
          var elem = 'event-' + edge_event + '-video-' + eventurlid
          elem = document.getElementById(elem)
          if (elem.requestFullscreen) {
            elem.requestFullscreen()
          } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen()
          } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen()
          } else if (elem.webkitEnterFullScreen != undefined) {
            elem.webkitEnterFullScreen() // Safari
          }
        } catch (e) {}
      }
      $scope.showEventVidoesModal = function (edge, edge_event, ev) {
        $mdDialog
          .show({
            locals: {
              dataFromCaller: {
                edge: edge,
                edge_event: edge_event
              }
            },
            controller: 'EdgeEventVideosController',
            templateUrl:
              './templates/edge.event.videos.view.html?t=' + window.webpackHash,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(
            function (response) {
              var event_index = -1
              for (var j = 0; j < $scope.edge_events_array.length; j++) {
                var e = $scope.edge_events_array[j]
                if (e.id == event.id) {
                  event_index = j
                  break
                }
              }
              if (event_index > -1) {
                if (!$scope.edge_events_array[event_index].event_video_urls) {
                  $scope.edge_events_array[event_index].event_video_urls = []
                }
                $scope.edge_events_array[event_index].event_video_urls[i] = {
                  id: i + 1,
                  url: response.data.url,
                  playStatus: false,
                  event_index: event_index,
                  duration: 0,
                  duration_found: true
                }
                $timeout(function () {
                  var k = i + 1
                  var elem = 'event-' + event.id + '-video-' + k
                  elem = document.getElementById(elem)
                  if (elem) {
                    elem.addEventListener(
                      'timeupdate',
                      function () {
                        seektimeupdate(event.id, k)
                      },
                      false
                    )
                    elem.addEventListener(
                      'ended',
                      function () {
                        updatePlayPauseIcon(event.id, event_index, i)
                      },
                      false
                    )
                    elem.addEventListener(
                      'loadeddata',
                      function () {
                        getVideoDuration(event.id, event_index, i)
                      },
                      false
                    )
                  }
                })
              }
            },
            function () {
              //
            }
          )
      }
      $scope.showEventDashboard = function () {
        $scope.$emit('showDashboardData', {})
        $state.go('home.common.events.dashboard', {
          imei: $scope.edge.imei,
          eventSearch: $scope.eventSearch
        })
      }

      $localStorage.firstTime = 0
      $scope.showFilter = function (ev, edge) {
        $mdDialog
          .show({
            locals: {
              dataFromCaller: {
                edge: edge,
                selectedFilterEvents: angular.copy(selectedFilterEvents)
              }
            },
            controller: 'EventsFilterController',
            templateUrl:
              './templates/event.filters.view.html?t=' + window.webpackHash,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(function (response) {
            if (response) {
              $scope.edge_events_array = []
              $scope.userSelectedFilterEvents = response
              $scope.filteringEventsModule(response)
              selectedFilterEvents = $scope.userSelectedFilterEvents
            }
          })
          .catch(() => {})
      }

      $scope.filteringEventsModule = function (response) {
        $scope.edge_events_array = []
        if (response) {
          $scope.filterActivated =
            response.length !== $scope.available_edge_event_settings.length
          if ($scope.total_edge_events) {
            const selectedFilterEventNames = response.map(e => e.v2Name)
            $scope.edge_events_array = $scope.total_edge_events.filter(e =>
              selectedFilterEventNames.includes(e.eventType)
            )
          }
        }
      }

      function loadData () {
        const edge = $scope.edge
        $scope.eventsSidenav = false
        $scope.disabledValue = false
        $scope.edge_event_history_loading = true
        $scope.edge_events_array = []

        $scope.resetEventSearch()
        $scope.edge_events = {}

        // To get the all filter data until this variable false

        $scope.edge_events_obj = {}
        $scope.existEvents = angular.copy(deviceEventSettings)

        const yAxisData = ''
        $scope.AxisValues = yAxisData
        $scope.eventsvide_loading = false

        $scope.scrolllValue = true
        $scope.images = [1, 2, 3, 4, 5, 6, 7, 8]
        $scope.timeout_timer = null
        $scope.getEdgeEvents(edge, true)

        $scope.$emit('EdgeEventsStatus', {})
      }

      if ($scope.edge) {
        loadData()
      } else {
        $scope.$on(LOAD_DEVICE_DETAILS.RESPONSE, function (
          e,
          { imei: deviceImei }
        ) {
          const { item } = edgeFactoryV2.findItemByImei(deviceImei)
          $scope.edge = item
          loadData()
        })
      }

      function updatePlayPauseIcon (
        edge_event_id,
        event_index,
        eventurlid,
        edge_id
      ) {
        $scope.edge_events_array[event_index].event_video_urls[
          eventurlid
        ].playStatus = false
      }

      function getVideoDuration (edge_event_id, event_index, eventurlid) {
        var streamid = eventurlid + 1
        var vid = 'event-' + edge_event_id + '-video-' + streamid
        vid = document.getElementById(vid)
        if (vid) {
          $scope.edge_events_array[event_index].event_video_urls[
            eventurlid
          ].duration = vid.duration
          $scope.edge_events_array[event_index].event_video_urls[
            eventurlid
          ].duration_found = true
          $scope.eventsvide_loading = false
        }
      }

      function getSuspendVideos (edge_event_id, event_index, eventurlid) {
        var streamid = eventurlid + 1
        var vid = 'event-' + edge_event_id + '-video-' + streamid
        vid = document.getElementById(vid)
        if (vid) {
          $scope.edge_events_array[event_index].event_video_urls[
            eventurlid
          ].duration = vid.duration
          $scope.edge_events_array[event_index].event_video_urls[
            eventurlid
          ].duration_found = true
          $scope.eventsvide_loading = false
        }
      }

      function seektimeupdate (edge_event_id, eventurlid) {
        var vid = 'event-' + edge_event_id + '-video-' + eventurlid
        vid = document.getElementById(vid)
        if (vid) {
          var nt = vid.currentTime * (100 / vid.duration)
          var seeksliderID = edge_event_id + '-seekslider-' + eventurlid
          var seekslider = document.getElementById(seeksliderID)
          seekslider.value = nt
          var curmins = Math.floor(vid.currentTime / 60)
          var cursecs = Math.floor(vid.currentTime - curmins * 60)
          var durmins = Math.floor(vid.duration / 60)
          var dursecs = Math.floor(vid.duration - durmins * 60)
          if (cursecs < 10) {
            cursecs = '0' + cursecs
          }
          if (dursecs < 10) {
            dursecs = '0' + dursecs
          }
          if (curmins < 10) {
            curmins = '0' + curmins
          }
          if (durmins < 10) {
            durmins = '0' + durmins
          }
          var curtimetextID = edge_event_id + '-curtimetext-' + eventurlid
          var durtimetextID = edge_event_id + '-durtimetext-' + eventurlid
          var curtimetext = document.getElementById(curtimetextID)
          var durtimetext = document.getElementById(durtimetextID)
          curtimetext.innerHTML = curmins + ':' + cursecs
          durtimetext.innerHTML = durmins + ':' + dursecs
        }
      }

      function handleServerError (response) {
        $scope.$emit('handleServerError', response)
      }

      $scope.UnitSystem = UnitSystem
      if ($localStorage.measurementUnits === 1) {
        SystemConstants.unit = 1
      } else {
        SystemConstants.unit = 0
      }
    }
  ])
